import backendRequest from "./index.js";
import statuses from '../../components/constants/register_status.json';

const getEvents = ({ cursorId } = { cursorId: 0 }) =>
    backendRequest("GET", `/events/list?cursor_id=${cursorId}`);

const getEventsForDiploma = () => backendRequest("GET", `/events/get-events-for-diploma`);

const getSponsorsForEvent = (id) => backendRequest("GET", `/events/get-sponsors/${id}`);

const getEventData = (code, { withLongTexts } = { withLongTexts: false }) =>
    backendRequest("GET", `/events/get/by-code/${code}?with_long_texts=${withLongTexts ? 1 : 0}`);

const getEventSchedule = (code) => backendRequest("GET", `/events/get-schedule/${code}`);

const getEventScriptForCurrentUser = (event_id) =>
    backendRequest("GET", `/events/get-script-for-me/${event_id}`);

const getEventsForCurrentUser = ({ cursorId } = { cursorId: 0 }) =>
    backendRequest("POST", `/events/list/for-current-user`, { cursor_id: cursorId });

const registerUserForEvent = (eventId, data) =>
    backendRequest("POST", `/events/register/${eventId}`, { ...data });

const updateUserRegistration = (eventId, competitions) =>
    backendRequest("POST", `/events/update-register/${eventId}`, { competitions });

const unregisterUserFromEvent = (eventId, competitions) =>
    backendRequest("POST", `/events/unregister/${eventId}`);

const getPlayersForEvent = (eventId) => backendRequest("GET", `/events/get-players/${eventId}`);

const isCurrentUserRegistered = (eventId) =>
    backendRequest("POST", `/events/current-user-registered/${eventId}`);

const registerUpgrade = (eventId) => backendRequest("POST", `/events/register-upgrade/${eventId}`);

const getResultsForUser = (eventId) =>
    backendRequest("GET", `/events/get-results-for-me/${eventId}`);

const sendPaymentReminder = (eventId) =>
    backendRequest("GET", `/event-management/send-payment-reminder/${eventId}`);

const syncRegistrations = (eventId) =>
    backendRequest("POST", `/event-management/sync-registrations`, { event_id: eventId });

const grabResults = (eventId) =>
    backendRequest("GET", `/event-management/grab-results/${eventId}`);

const sendPhotosAvailableNotification = (eventId) => 
    backendRequest("GET", `/event-management/send-photos-available-notification/${eventId}`);

const markRegistrationAsConfirmed = (eventId, userId, isFree) =>
    backendRequest("POST", `/event-management/mark-registration-as-confirmed`, { eventId, userId, isFree });

const updatePlaces = (eventId, places) =>
    backendRequest("POST", `/event-management/update-places/${eventId}`, { places });

const getEventDates = (eventId) => backendRequest("GET", `/event-management/dates/${eventId}`);

const updateEventDates = (eventId, dates) =>
    backendRequest("POST", `/event-management/update-dates/${eventId}`, dates);

const uploadLogo = (eventId, logo) => backendRequest("POST", `/event-management/upload-logo/${eventId}`, logo, "multipart/form-data");

const getPeopleWithFreeRegistration = (eventId) => backendRequest("GET", `/event-management/get-free-registrations/${eventId}`);

const getEventRoles = () => backendRequest("GET", `/event-management/get-event-roles`);

const updateEventRoles = (eventId, data) => backendRequest("POST", `/event-management/update-event-roles/${eventId}`, data);

const getRegisterStatus = (status) => {
    return statuses[status] || null;
}

export {
    isCurrentUserRegistered,
    getEvents,
    getEventsForCurrentUser,
    getEventData,
    getEventScriptForCurrentUser,
    getEventSchedule,
    getPlayersForEvent,
    getResultsForUser,
    registerUserForEvent,
    registerUpgrade,
    updateUserRegistration,
    unregisterUserFromEvent,
    getSponsorsForEvent,
    getEventsForDiploma,
    sendPaymentReminder,
    syncRegistrations,
    sendPhotosAvailableNotification,
    grabResults,
    markRegistrationAsConfirmed,
    getRegisterStatus,
    updatePlaces,
    getEventDates,
    updateEventDates,
    uploadLogo,
    getPeopleWithFreeRegistration,
    getEventRoles,
    updateEventRoles,
};
